function Footer () {
    const MyStyle1 =  {
          color: "black",
          fontSize: "2.2vmin"        
      }

    return (
        <div style={MyStyle1}>            
            &copy; 2025 www.raliwa.de – &nbsp;
            <a href="/impressum" style={MyStyle1}>Impressum</a>            
        </div>    
    )
}

export default Footer;